import { render, staticRenderFns } from "./ALBTargetGroupManager.vue?vue&type=template&id=dec30e56&scoped=true&"
import script from "./ALBTargetGroupManager.vue?vue&type=script&lang=js&"
export * from "./ALBTargetGroupManager.vue?vue&type=script&lang=js&"
import style0 from "./ALBTargetGroupManager.vue?vue&type=style&index=0&id=dec30e56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec30e56",
  null
  
)

export default component.exports